import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../config/firebase';
import { doc, getDoc } from 'firebase/firestore';
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import CourseInformation from "../components/CourseInformation";

const CoursePages = () => {
  const { courseid } = useParams();
  const [course, setCourse] = useState(null);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const docRef = doc(db, 'Course', courseid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setCourse(docSnap.data());
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Error fetching course:', error);
      }
    };

    fetchCourse();
  }, [courseid]);
  
  if (!course) return <p>Loading...</p>;

  return (
    <div className="page-container">
      <NavBar />
      <div className="course-header">
        <h1 className="course-title">{course.Title}</h1>
      </div>
      <CourseInformation course={course} />
      <Footer />

      <style jsx>{`
        .page-container {
          background-color: #f9fbfd;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .course-header {
          text-align: center;
          margin: 40px 20px;
        }

        .course-title {
          font-size: 3rem;
          font-weight: bold;
          color: #2c3e50;
          margin-top:60px;
                    overflow-wrap: break-word;

        }
@media (max-width: 768px) {
          .course-title {
            font-size: 2.7rem;
          }
      }
        .course-description {
          font-size: 1.5rem;
          color: #7f8c8d;
          margin-top: 10px;
        }
          .footer{
          margin-top:20px;}
      `}</style>
    </div>
  );
};

export default CoursePages;
